import './index.css'

const Application = () => (
  <div className="Application-container">
    <img
      src="https://www.appstudio.ca/blog/wp-content/uploads/2020/09/Modern-Software-Development.jpg"
      alt="application"
      className="apl-image"
    />
    <h1 className="apl-heading">Application Development</h1>
    <h1 className="apl-heading2">
      Do you need custom-made applications for your business process
      development?
    </h1>
    <p className="apl-paragraph">
      Amrutha Systems boasts world-class capabilities in building scalable,
      robust, integrated, and highly secure distributed enterprise applications
      with high throughput and low latency. Our best-in-class technology experts
      have deep knowledge of the Java technology stack and insights into the
      NoSQL landscape and emerging computing platforms such as Spark. We
      leverage Agile and Continuous Delivery practices to ensure on-time and
      high-quality delivery <br /> Our engineers have helped several Fortune 500
      clients build software on various platforms using the most appropriate
      enterprise architectures and technologies for application development. We
      have used Business Process Management (BPM) products to build efficient
      operational systems, robust distributed architectures, global billing
      platforms, highly efficient algorithmic trading software, and many others.
    </p>
    <div className="first">
      <div className="image-scale-container">
        <img
          src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTbk5Z2HwpijugTLfd-xMEhWNNatTHszPrYL0EwZ5Kv1xSAxUo&s"
          alt="apl1"
          className="apl-1"
        />
      </div>
      <div className="scale-content">
        <h1 className="heading-scale">‍Scalable architecture</h1>
        <p className="scale">
          Ensuring the scalability of applications, in the long run, is a
          cornerstone of effective in-app development and application
          architecture. We have designed systems for multiple use cases and
          clients, using distributed open platforms and cloud solutions. Our
          highly skilled architects and engineers are adept at defining and
          designing scalable systems.
        </p>
      </div>
    </div>
    <div className="first">
      <div className="scale-content">
        <h1 className="heading-scale">‍Information security architecture</h1>
        <p className="scale">
          Security Architecture is an important aspect of Enterprise
          Architecture and has become all the more critical in the recent past.
          Our security consultants understand the nuances of integrating
          security at various levels in a global enterprise and are adept at
          aligning security goals with the business. We have helped major banks
          and telecom giants establish a coherent, comprehensive, and strong
          security across systems, divisions, and geographies.
        </p>
      </div>
      <div className="security">
        <img
          src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTmb0owtqwx7lp_J_eEQKvBE0uiKDOavYr0SzbWe8MEKCFVdFOd&s"
          alt="apl1"
          className="apl-1"
        />
      </div>
    </div>
  </div>
)
export default Application
